import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import i18n from "@/plugins/i18n";
import Config from "@/config/config";
Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/",
    redirect: "/en",
  },
  {
    path: "/403",
    name: "forbidden",
    component: () => import(/* webpackChunkName: "error" */ "../views/errors/403.vue"),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import(/* webpackChunkName: "error" */ "../views/Maintenance.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import(/* webpackChunkName: "error" */ "../views/errors/404.vue"),
    alias: "*",
  },
  {
    path: "/500",
    name: "500",
    component: () => import(/* webpackChunkName: "error" */ "../views/errors/500.vue"),
  },
  {
    path: "/contract/:contractID",
    redirect: "/en/contractStatus/:contractID",
  },
  {
    path: "/:lang(en|tc|sc)",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    beforeEnter: (to, from, next) => {
      i18n.locale = to.params.lang ?? "en";
      next();
    },
    children: [
      {
        path: "",
        name: "landing",
        component: () => import(/* webpackChunkName: "home" */ "../views/Captcha.vue"),
      },
      {
        path: "lidar",
        name: "lidar",
        component: () => import(/* webpackChunkName: "home" */ "../views/LiDAR/LiDARView.vue"),
      },
      {
        path: "dm-auth",
        name: "digitalMap",
        component: () => import(/* webpackChunkName: "home" */ "../views/DM/AuthContractor.vue"),
      },
      {
        path: "dm",
        name: "dm",
        component: () => import(/* webpackChunkName: "home" */ "../views/DM/DMView.vue"),
      },
      {
        path: "orderSuccess",
        name: "orderSuccess",
        component: () => import(/* webpackChunkName: "home" */ "../views/DM/SubmitSuccess.vue"),
      },
      {
        path: "orderStatus/:orderID",
        name: "orderStatus",
        component: () => import(/* webpackChunkName: "home" */ "../views/DM/OrderStatus.vue"),
      },
      {
        path: "contractStatus/:contractID",
        name: "contractStatus",
        component: () => import(/* webpackChunkName: "home" */ "../views/DM/contractStatus.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

/**
 * 1. checking the token from vaildate the captcha
 * 2. checking the token from dmAuth when access dm
 */

if (process.env.NODE_ENV !== "development") {
  // if (process.env.VUE_APP_ENV !== "test" && process.env.NODE_ENV !== "development") {
  //   if (to.name == "maintenance") {
  //     router.go("/404");
  //   }
  // }
  router.beforeEach(async function (to, from, next) {
    if (
      to.name == "forbidden" ||
      to.name == "404" ||
      to.name == "500" ||
      to.name == "landing" ||
      to.name == "orderStatus" ||
      to.name == "contract" ||
      to.name == "contractStatus" ||
      to.name == "maintenance"
    ) {
      next();
    } else {
      let url = "";
      if (to.name == "dm") {
        url = Config.urls.validateProjectToken;
      } else if (to.name == "orderSuccess") {
        url = Config.urls.validateOrderToken;
      } else {
        url = Config.urls.validateCaptchaToken;
      }
      axios
        .get(url, { headers: { authorization: "Bearer " + sessionStorage.token } })
        .then(() => {
          //refresh token
          //sessionStorage.token=res.data.token;
          next();
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            next({ name: "landing" });
          } else if (error.response?.status == 403 || error.code == "ECONNABORTED") {
            next({ name: "forbidden" });
          } else {
            router.go("/error");
          }
        });
    }
  });
}

// To prevent NavigationDuplicated Error.
// For more information, please check https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};

export default router;
